import { ServiceRequestBase } from "../ServiceRequestBase";

export class UpdateUsernameRequest extends ServiceRequestBase {
  public UserId: number | null = null;
  public Username: string = '';
}
